import { Img } from '@/components/blocks/MaterialImage';
import { Box } from '@mui/material';

interface OutfitImageProps {
	image: string;
}

export const OutfitImage: React.FC<OutfitImageProps> = ({ image }) => {
	// Adjust layout based on device type
	return (
		<Box sx={{ flex: 1, maxHeight: { xs: '309px', md: '100%' } }}>
			<Img src={image} alt="Outfit" sx={{ width: '100%', height: 'auto' }} />
		</Box>
	);
};
